import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "reactflow/dist/style.css";
import SliderBarMaps from "../../../../componentes/easyMaps/sideBarEasyMaps";
import api from "../../../../services/apiPublic";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import MenuMaps from "../../../../componentes/easyMaps/menuMaps";
import ReactFlowMapas from "./reactFlowMapa";
import AlertModal from "../../../../componentes/alertModal";
import LoadingUpdate from "../../../../componentes/easyMaps/loadingUpdate";
import { MapaContext } from "../../../../contexts/mapaContext";
import ToastAlert from "../../../../componentes/easyMaps/toastAlert";
import { ToastContainer } from "react-toastify";
//import useUndoable from "use-undoable";

const MapaTopologiaPublic = () => {
  const tipo = "easymon";
  const [snackbar, setSnackbar] = useState(null);
  const [produtos, setProdutos] = useState(false);
  const theme = useTheme();
  const [map, setMap] = useState({});
  const [configurationMap, setConfigurationMap] = useState(null);
  const [elements, setElements] = useState([]);
  const [elementSelected, setElementSelected] = useState(null);
  const [connections, setConnections] = useState([]);
  const [connectionsAnalog, setConnectionsAnalog] = useState([]);
  const [connectionSelected, setConnectionSelected] = useState(null);
  const [edgeSelected, setEdgeSelected] = useState(null);
  const [checkChanges, setCheckChanges] = useState(false);
  const [elementsConnected, setElementsConnected] = useState([]);
  const [fullScreem, setFullScreem] = useState(false);
  const [iconsElements, setIconsElements] = useState([]);
  const [openRightBar, setOpenRightBar] = useState(false);
  const [mapas, setMapas] = useState([]);
  const [sinc, setSinc] = useState(false);
  const [focusNodeId, setFocusNodeId] = useState(null);
  const [coordenadasFlow, setCoordenadasFlow] = useState(null);
  const [loadingMap, setLoadingMap] = useState(true);
  const [loadinButtonEnlace, setLoadinButtonEnlace] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [lastCollectData, setLastCollectData] = useState(null);

  // atualização otimização
  const [hostsDataMap, setHostsDataMap] = useState(new Map());
  const [alertsDataMap, setAlertsDataMap] = useState(new Map());
  const [connectionsDataMap, setConnectionsDataMap] = useState(new Map());
  const [configElementDataMap, setConfigElementDataMap] = useState(new Map());

  const [soundState, setSoundState] = useState(false);
  const [newAlerts, setNewAlerts] = useState([]);

  const [
    connectionsDataMapPercentTraffic,
    setConnectionsDataMapPercentTraffic,
  ] = useState(new Map());
  const [connectionsDataMapPercentPower, setConnectionsDataMapPercentPower] =
    useState(new Map());

  const navigate = useNavigate();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const { id } = useParams();
  const { socket, config, configLayer, setConfigLayer } = useOutletContext();

  const isMobile =
    navigator.userAgentData?.mobile === true ||
    window.matchMedia("(pointer: coarse)").matches;

  const styles = {
    fullScreem: {
      position: "fixed",
      zIndex: 1500,
      width: "100dvw",
      height: "100dvh",
      left: 0,
      top: 0,
    },
    noFullScreem: {
      position: "relative",
      ml: { xs: "0px", md: collapse ? "0px" : "340px" },
      width: {
        xs: "100dvw",
        md: "calc(100dvw - " + (collapse ? "0px" : "340px") + ")",
      },
      height: { xs: "calc(100dvh - 60px)", sm: "calc(100dvh - 67px)" },
    },
    loadingMap: {
      position: "absolute",
      zIndex: 1000,
      width: "100%",
      height: "100%",
      backgroundColor: "#00000093",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: 4,
    },
    toastContainer: {
      zIndex: fullScreem ? 1501 : 1200,
      marginTop: (sinc || loadingMap ? 55 : 0) + (fullScreem ? 0 : 60) + "px",
      marginRight: elementSelected ? "355px" : "0",
    },
  };

  useEffect(() => {
    if (newAlerts.length === 0) return;

    newAlerts.forEach((alert, index) => {
      const element = elements.get(alert.elementId);

      ToastAlert({
        alert,
        focus: setFocusNodeId,
        element,
        theme,
        sound: index === 0 && soundState, // Toca o som apenas para o primeiro alerta da lista
      });
    });

    setNewAlerts([]);
  }, [newAlerts]);

  useEffect(() => {
    if (!id || !config) return;
    handleApi();
  }, [id, config]);

  useEffect(() => {
    setCollapse(isSmall);
  }, [isSmall]);

  useEffect(() => {
    // atualiza as confi de layer do mapa para o default
    if (!configLayer?.[id]) {
      setConfigLayer((configLayer) => ({
        ...configLayer,
        [id]: "trafego",
      }));
    }

    let timeInterval = config?.configuracoes?.top?.atualizacao || 60000;
    const interval = window.setInterval(() => {
      updateDataElementSocket();
    }, timeInterval);
    return () => window.clearInterval(interval);
  }, [id, config]);

  async function handleApi() {
    try {
      setLoadingMap(true);
      setElementSelected(null);
      setConnectionSelected(null);
      await Promise.all([
        handleApiGetMap(id),
        handleApiGetMaps(),
        handleApiGetElements(id),
        getIconDB(),
      ]);
    } catch (error) {
    } finally {
      setLoadingMap(false);
    }
  }

  //-----funcoes de chamada a api
  async function handleApiGetElements(id) {
    try {
      //setLoadingProdutos(true);
      const response = await api.post("/easyMaps/public/element/findMany", {
        mapId: id,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const data = response.data;
        // transforma os elements em MAP
        let elements = new Map(data.responseAlerts.map((el) => [el.id, el]));
        let connections = new Map(data.connections.map((el) => [el.id, el]));

        setElements(elements);
        setConnections(connections);
        updateDataElementSocket();
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  async function handleApiGetMap(mapId) {
    try {
      const response = await api.post("/easyMaps/public/map/findMapById", {
        mapId,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const { ConfigMapEasyMaps, ...map } = response.data;
        setMap(map);
        if (ConfigMapEasyMaps) {
          setConfigurationMap(ConfigMapEasyMaps);
        } else {
          //usa a configurações globais
          setConfigurationMap({
            configuracoes: config?.configuracoes?.top || null,
          });
        }
      }
    } catch (error) {
      console.error(error);
      if (error?.response?.status == 404) navigate("/easyMaps/pages/notFound");
      if (error?.response?.status == 401)
        setOpenAlertModal({
          open: true,
          severity: "error",
          text: "Você não tem permissão para acessar este mapa, solicite permissão ao administrador",
        });
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      //setLoadingProdutos(false);
    }
  }
  async function updateDataElementSocket() {
    try {
      setSinc(true);
      socket.emit("getDataElementsMap", { mapId: id }, (response) => {
        setSinc(false);
        if (response.status !== 200) {
          setSnackbar({
            children: "Error: Não foi possível atualizar os elementos",
            severity: "error",
          });
        } else {
          // trnsforma os elements em MAP
          const updatedData = response?.data;
          const newHostsMap = new Map();
          const newAlertsMap = new Map();
          const newConnectionsMap = new Map();
          const configElementMap = new Map();
          let connGroupedByPercentegeTrafego = {};
          let connGroupedByPercentegePotencia = {};

          for (const el of updatedData.elementosResponse) {
            // hosts por elemento
            if (el.hosts?.length) {
              newHostsMap.set(el.id, el.hosts);
            }

            // conexões concatenadas
            for (const conn of el.connections) {
              //trafego
              if (conn.percentual in connGroupedByPercentegeTrafego) {
                connGroupedByPercentegeTrafego[conn?.corTraffic?.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegeTrafego[conn?.corTraffic?.label] = [
                  conn.id,
                ];
              }
              //potencia
              if (conn.percentualPotencia in connGroupedByPercentegePotencia) {
                connGroupedByPercentegePotencia[conn?.corPower?.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegePotencia[conn?.corPower?.label] = [
                  conn.id,
                ];
              }
              newConnectionsMap.set(conn.id, conn);
            }

            // alerts por elemento (ou por host, se preferir)
            if (el.alerts?.length) {
              newAlertsMap.set(el.id, el.alerts);

              // somente os novos
              const newAlerts = el.alerts.filter((alert) => alert.isNew);

              if (newAlerts.length > 0) {
                setNewAlerts((prev) => {
                  const existingKeys = new Set(
                    prev.map((a) => `${a.triggerid}-${a.eventid}`),
                  );

                  const filtered = newAlerts.filter(
                    (a) => !existingKeys.has(`${a.triggerid}-${a.eventid}`),
                  );

                  return [...prev, ...filtered];
                });
              }
            }
            configElementMap.set(el.id, el.config);
          }
          setHostsDataMap(newHostsMap);
          setAlertsDataMap(newAlertsMap);
          setConnectionsDataMap(newConnectionsMap);
          setConfigElementDataMap(configElementMap);
          setLastCollectData(updatedData?.dataColeta || null);
          // conexões agrupadas por percentual
          setConnectionsDataMapPercentTraffic(
            new Map(Object.entries(connGroupedByPercentegeTrafego)),
          );
          setConnectionsDataMapPercentPower(
            new Map(Object.entries(connGroupedByPercentegePotencia)),
          );
        }
      });
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possível atualizar",
        severity: "error",
      });
    }
  }
  async function handleApiGetMaps() {
    try {
      const response = await api.get("/easyMaps/public/map/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMapas(
            response.data.map((map) => ({
              nome: map?.titulo,
              id: map?.id,
              tipo: map?.tipo,
            })),
          );
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function getIconDB() {
    try {
      const response = await api.get("/easyMaps/public/img/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar os icons",
          severity: "error",
        });
      } else {
        setIconsElements(response.data);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      // setHostLoading(false);
    }
  }

  const changeConnection = (edgeId, updateConfig, updateData) => {
    setCheckChanges(true);
    setConnections((cons) => {
      return cons.map((con) => {
        if (con.id === edgeId)
          return {
            ...con,
            ...updateData,
            config: {
              ...con?.config,
              ...updateConfig,
            },
          };
        else return con;
      });
    });
  };

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const handleFullscreen = (value) => {
    setFullScreem(value);
    if (!isMobile) setCollapse(value);
  };

  const addMapInMaps = (map) => {
    setMapas([...mapas, { nome: map?.titulo, tipo: map?.tipo, id: map?.id }]);
  };
  return (
    //Atenção: O contexto MapaContext é usado para compartilhar o estado do mapa e elementos entre os componentes filhos,
    // nas proximas atualizações usem essa forma para organizar o acesso aos dados do mapa.
    // Isso facilita a manutenção e a escalabilidade do código.
    // e Se possivel, removam os props desnecessários dos componentes filhos.
    <MapaContext.Provider
      value={{
        mapId: id,
        tipo: "top",
        elements,
        elementSelected,
        setElementSelected,
        connections,
        setConnectionSelected,
        snackbar,
        setSnackbar,
        isPublic: true,
        updateDataElementSocket,
        configurationMap,
        hostsDataMap,
        alertsDataMap,
        connectionsDataMap,
        lastCollectData,
        configElementDataMap,
        setConnectionSelected,
        configurationMap,
        setConfigurationMap,
        connectionsDataMapPercentTraffic,
        connectionsDataMapPercentPower,
        soundState,
        setSoundState,
      }}
    >
      <ToastContainer
        style={styles.toastContainer}
        newestOnTop
        limit={isMobile ? 4 : 5}
      />
      <Stack direction="row">
        <SliderBarMaps
          map={map}
          iconsElements={iconsElements}
          elements={elements}
          setFocusNodeId={setFocusNodeId}
          collapse={collapse}
          handleCollapse={handleCollapse}
          fullscreen={fullScreem}
          isPublic={true}
        />
        <Stack sx={!fullScreem ? styles.noFullScreem : styles.fullScreem}>
          {loadingMap && (
            <Box sx={styles.loadingMap}>
              <CircularProgress size="50px" />
              <Typography fontSize="14px">
                Carregando dados do mapa...
              </Typography>
            </Box>
          )}
          <LoadingUpdate
            visible={sinc && !loadingMap}
            elementSelected={!!elementSelected}
          />
          <ReactFlowMapas
            setEdgeSelected={setEdgeSelected}
            connectionsAnalog={connectionsAnalog}
            setElementsConnected={setElementsConnected}
            connectionSelected={connectionSelected}
            setConnectionSelected={setConnectionSelected}
            iconsElements={iconsElements}
            setOpenRightBar={setOpenRightBar}
            setLoadingPage={setLoadingMap}
            focusNodeId={focusNodeId}
            fullScreem={fullScreem}
            setFullScreem={handleFullscreen}
            mapId={id}
            title={map?.titulo}
            checkChanges={checkChanges}
            setCoordenadasFlow={setCoordenadasFlow}
            setConnections={setConnections}
            edgeSelected={edgeSelected}
            coordenadasFlow={coordenadasFlow}
            elementsConnected={elementsConnected}
            openRightBar={openRightBar}
            setFocusNodeId={setFocusNodeId}
            socketCliente={socket}
            mapas={mapas}
            addMapInMaps={addMapInMaps}
            produtos={produtos}
            changeConnection={changeConnection}
            setCheckChanges={setCheckChanges}
            updateDataElementSocket={updateDataElementSocket}
            loadinButtonEnlace={loadinButtonEnlace}
            collapse={collapse}
          />
          {/* {false && (
            <MenuMaps
              setElementSelected={setElementSelected}
              iconsElement={iconsElements.filter((icon) =>
                icon?.nome?.startsWith("_")
              )}
              setConnectionSelected={setConnectionSelected}
            />
          )} */}
        </Stack>
      </Stack>
      <AlertModal
        openModal={openAlertModal?.open ?? false}
        setOpenModal={(data) => setOpenAlertModal({ open: data })}
        severity={openAlertModal?.severity}
        buttonText={openAlertModal.buttonText || "Voltar"}
        buttonCancelText={openAlertModal.buttonCancelText}
        textContent={openAlertModal?.text}
        handleButton={() => {
          setOpenAlertModal({ open: false });
          navigate(-1);
        }}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}{" "}
    </MapaContext.Provider>
  );
};
export default MapaTopologiaPublic;
